export default {

  transformPosts(posts) {
    const transformed = [];

    for(let post of posts) {
      transformed.push(
        this.transformPost(post)
      );
    }

    return transformed;
  },

  transformPost(wpPost) {
    let post = wpPost.acf;

    post.id = wpPost.id;
    post.title = wpPost.title.rendered;
    post.content = wpPost.content.rendered;
    post.slug = wpPost.slug;

    if (post.place && post.place.indexOf('mixlr') > 1) {
      post.place = null;
    }

    post.original = wpPost;

    return post;
  }
};
